// src/api/notifications.js
import dynamicAPI from './dynamicAPI';
import { useMutation, useQuery, useQueryClient } from 'react-query';

export default function useNotifications({
                                             page = 1,
                                             limit = 20,
                                             unreadOnly = false,
                                             refetchMs = 15000,          // polling interval; set to 0/false to disable
                                         } = {}) {
    const qc = useQueryClient();

    const list = useQuery(
        ['notifications', page, limit, unreadOnly],
        async () =>
            await dynamicAPI(
                'get',
                `/api/auth/notifications?page=${page}&limit=${limit}${unreadOnly ? '&unread=1' : ''}`
            ),
        {
            retry: 0,
            staleTime: 30_000,            // cache item for 30s before considered stale
            cacheTime: 5 * 60_000,        // keep in cache 5 minutes
            refetchOnWindowFocus: true,   // refresh when user focuses the tab
            refetchInterval: refetchMs || false, // polling
        }
    );

    const markRead = useMutation(
        async (id) => await dynamicAPI('post', `/api/auth/notifications/${id}/read`),
        { onSuccess: () => qc.invalidateQueries('notifications') }
    );

    const markAll = useMutation(
        async () => await dynamicAPI('post', `/api/auth/notifications`),
        { onSuccess: () => qc.invalidateQueries('notifications') }
    );

    return { list, markRead, markAll };
}
